// ** React Imports
import { useContext, useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { Button, Input, Label, Card, CardBody, Col } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { useReactOidc } from "@axa-fr/react-oidc-context"

// ** Custom Components
import Loading from "@views/common/Loading"
import Notification from "@views/common/Notification"
import { alertCustom, alertCustomInfo } from "@views/common/NotificationClient"

// ** Context
import { IntlContext } from "@src/utility/context/Internationalization"

// ** Third Party Components
import { getOTPEmail, verifyChangeEmail } from "@services/PersonService"
import { useParams } from "react-router-dom"
import { getSystemParameterByCode } from "../../services/SystemParameterService"

const ChangeEmail = () => {
    const intl = useIntl()
    const { oidcUser, login, logout } = useReactOidc()
    const intlContext = useContext(IntlContext)
    const headers = {
        Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
        "Accept-Language": intlContext.locale
    }

    const timeCountDown = 120

    const { email } = useParams()

    const eye = <FontAwesomeIcon icon={faEye} />
    const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [passwordShow, setPasswordShow] = useState(false)
    const [valueEmail, setValueEmail] = useState('')
    const [currentPassword, setCurrentPassword] = useState('')
    const [valueOtp, setValueOtp] = useState('')
    const [isGetOTP, setIsGetOTP] = useState(false)
    const [timeChangeEmail, setTimeChangeEmail] = useState(timeCountDown)
    const [countdownChangeEmail, setCountdownChangeEmail] = useState(timeCountDown)

    const getCountDownTime = () => {
        getSystemParameterByCode(headers, "otp-change-email")
            .then((res) => {
                if (res?.data?.time !== null || res?.data?.time !== '') {
                    setCountdownChangeEmail(res?.data?.time)
                    setTimeChangeEmail(res?.data?.time)
                }
            })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
            })
    }

    useEffect(() => {
        let intervalId

        if (isGetOTP && countdownChangeEmail > 0) {
            intervalId = setInterval(() => {
                setCountdownChangeEmail((prevCountdown) => prevCountdown - 1)
            }, 1000)
        } else {
            setIsGetOTP(false)
            setCountdownChangeEmail(timeChangeEmail)
        }

        return () => {
            clearInterval(intervalId)
        }
    }, [isGetOTP, countdownChangeEmail])

    useEffect(() => {
        login()
    }, [])

    useEffect(() => {
        intlContext.switchLanguage("vi")
    }, [intlContext])

    useEffect(() => {
        if (oidcUser) {
            login()
            getCountDownTime()
        }
    }, [oidcUser])

    const getOtp = () => {
        setLoading(true)
        getOTPEmail(headers, {
            currentPassword,
            emailOld: email,
            emailNew: valueEmail
        })
            .then((res) => {
                alertCustom("success", `${intl.formatMessage({ id: "layOtpEmail" })}`)
                setIsGetOTP(true)
            })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
            })
    }

    const confirmChange = () => {
        setLoading(true)
        verifyChangeEmail(headers, {
            currentPassword,
            emailOld: email,
            emailNew: valueEmail,
            otp: valueOtp
        }).then((res) => {
            alertCustomInfo("info", `${intl.formatMessage({ id: "thayDoiEmailThanhCong" })}`)
            window.parent.postMessage("success-change-email", "*")
            setTimeout(() => {
                logout()
            }, 5000)
        })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
            })
    }

    const togglePasswordVisiblity = () => {
        setPasswordShow(!passwordShow)
    }

    return (
        <Card className="mb-0">
            {loading && <Loading />}
            {error && <Notification data={{ error }} />}
            <CardBody>
                <>
                    <Label className="label">{intl.formatMessage({ id: "pwdOld" })}</Label>
                    <div>
                        <Col md="12">
                            <Input
                                value={currentPassword}
                                type={passwordShow ? "text" : "password"}
                                maxLength="255"
                                onChange={(e) => setCurrentPassword(e.target.value)}
                            />
                            {passwordShow ? <i onClick={togglePasswordVisiblity} style={{ position: "absolute", cursor: "pointer", right: 25, marginTop: -29 }}>{eye}</i> : <i onClick={togglePasswordVisiblity} style={{ position: "absolute", cursor: "pointer", right: 25, marginTop: -29 }}>{eyeSlash}</i>}
                        </Col>
                    </div>

                    <Label className="label">{intl.formatMessage({ id: "Email" })}</Label>
                    <div>
                        <Col md="12">
                            <Input
                                value={valueEmail}
                                type="text"
                                maxLength="255"
                                onChange={(e) => setValueEmail(e.target.value)} />
                        </Col>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Col sm="3" className="mt-2">
                            {valueEmail !== '' && (
                                <Button
                                    color="primary"
                                    onClick={() => getOtp()}
                                    disabled={isGetOTP}
                                >
                                    <span style={{ display: 'inline-block', width: 90 }}>
                                        {isGetOTP ? `${intl.formatMessage({ id: "nhanOTP" })} (${countdownChangeEmail})` : intl.formatMessage({ id: "nhanOTP" })}
                                    </span>
                                </Button>
                            )}

                            {valueEmail === '' && (
                                <Button
                                    color="primary"
                                    disabled
                                >
                                    {intl.formatMessage({ id: "nhanOTP" })}
                                </Button>
                            )}
                        </Col>
                        <Col sm="9">
                            <Label className="label mr-1">{intl.formatMessage({ id: "maOTP" })}</Label>
                            <Input
                                value={valueOtp}
                                type="number"
                                maxLength="10"
                                onChange={(e) => setValueOtp(e.target.value)} />
                        </Col>
                    </div>
                </>
                <div className="d-flex justify-content-center mt-1">
                    {valueOtp !== '' && (
                        <Button color="primary" onClick={confirmChange}>
                            {intl.formatMessage({ id: "change" })}
                        </Button>
                    )}

                    {valueOtp === '' && (
                        <Button color="primary" disabled>
                            {intl.formatMessage({ id: "change" })}
                        </Button>
                    )}
                </div>
            </CardBody>

        </Card>
    )
}

export default ChangeEmail